module.exports = __webpack_public_path__ + "img/lego-2.beb7b8da.jpg";